<template>
    <div>
        <div style="font-weight: bold;font-size: 18px">对账查询</div>
        <el-form :inline="true">
            <el-form-item label="对账类别">
                <el-select v-model="queryCondition.category" clearable>
                    <el-option v-for="item in categoryTypes" :key="item.code" :label="item.desc" :value="item.code"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="对账目标">
                <el-input v-model="queryCondition.target" placeholder="币种"></el-input>
            </el-form-item>
            <el-form-item label="用户ID">
                <el-input v-model="queryCondition.userId"></el-input>
            </el-form-item>
            <el-form-item label="对账结果">
                <el-select v-model="queryCondition.result">
                    <el-option key="0" label="成功" value="0"/>
                    <el-option key="-1" label="失败" value="-1"/>
                </el-select>
            </el-form-item>
            <el-form-item label="对账时间">
                <el-date-picker v-model="datePicker" type="datetimerange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" value-format="timestamp"></el-date-picker>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="queryAccountList(1)">搜索</el-button>
            </el-form-item>
        </el-form>

        <el-table :data="accountList">
            <el-table-column label="对账类别" prop="category"/>
            <el-table-column label="对账目标" prop="target"/>
            <el-table-column label="对账类型">
                <template slot-scope="scope">{{scope.row.leftType}}/{{scope.row.rightType}}</template>
            </el-table-column>
            <el-table-column label="用户ID" prop="userId"></el-table-column>
            <el-table-column label="结果">
                <template slot-scope="scope">{{scope.row.result === 0 ? '成功' : '失败'}}</template>
            </el-table-column>
            <el-table-column label="阈值" prop="threshold"/>
            <el-table-column label="对账开始时间">
                <template slot-scope="scope">
                    <span>{{scope.row.startTime | moment}}</span>
                </template>
            </el-table-column>
            <el-table-column label="对账结束时间">
                <template slot-scope="scope">
                    <span>{{scope.row.endTime | moment}}</span>
                </template>
            </el-table-column>
            <el-table-column label="详情">
                <template slot-scope="scope">
                    <el-button type="text" @click="showDetail = true,detail = scope.row.detail">查看</el-button>
                </template>
            </el-table-column>
        </el-table>

        <el-pagination background layout="prev, pager, next" :total="accountTotal" :page-size="15" :current-page="queryCondition.page"
                       @current-change="queryAccountList"></el-pagination>

        <el-dialog title="对账详情" :visible.sync="showDetail" @close="showDetail = false,detail = ''">
            {{detail}}
        </el-dialog>
    </div>
</template>

<script>
    import './store';
    import api from './api';
    import {mapActions, mapState} from 'vuex';
    export default {
        name: "accountQuery",
        data(){
            return {
                datePicker:[],
                queryCondition:{
                    page:1,
                    category:'',
                    target: '',
                    userId: '',
                    start: '',
                    end: '',
                    result: '0',
                },
                showDetail: false,
                detail: '',
                categoryTypes:[{code:'TOTAL',desc:'总数'},{code:'USER_PLATFORM',desc:'用户与平台'}],
            }
        },
        computed : {...mapState('account',['accountTotal','accountList'])},
        methods: {
            ...mapActions('account',['queryList']),
            queryAccountList(val){
                this.queryCondition.page = val;
                if (this.datePicker) {
                    this.queryCondition.start = this.datePicker[0];
                    this.queryCondition.end = this.datePicker[1];
                }else {
                    this.queryCondition.start = '';
                    this.queryCondition.end = '';
                }
                this.queryList(this.queryCondition);
            },
        }
    }
</script>

<style scoped>

</style>
